import React from 'react';
import DashboardLayout from 'Layout/DashboardLayout';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import ChatSupportWidget from 'components/ChatSupportWidget';
import Card from '@mui/material/Card';

function ChatWidgetTest() {
  return (
    <DashboardLayout>
      <ArgonBox py={3}>
        <Card>
          <ArgonBox p={4}>
            <ArgonTypography variant="h3" mb={3}>
              Chat Widget Test Page
            </ArgonTypography>

            <ArgonTypography variant="body1" mb={2}>
              This page demonstrates the ChatSupportWidget component. The chat
              widget should appear as a floating button in the bottom-right
              corner of the screen.
            </ArgonTypography>

            <ArgonTypography variant="h5" mb={2}>
              Features:
            </ArgonTypography>

            <ArgonBox component="ul" pl={3} mb={3}>
              <ArgonBox component="li" mb={1}>
                <ArgonTypography variant="body2">
                  Floating chat button that opens/closes the chat window
                </ArgonTypography>
              </ArgonBox>
              <ArgonBox component="li" mb={1}>
                <ArgonTypography variant="body2">
                  Real-time messaging with API integration
                </ArgonTypography>
              </ArgonBox>
              <ArgonBox component="li" mb={1}>
                <ArgonTypography variant="body2">
                  Uses useAuth hook for authentication and Bearer token
                </ArgonTypography>
              </ArgonBox>
              <ArgonBox component="li" mb={1}>
                <ArgonTypography variant="body2">
                  Message history loading and persistence
                </ArgonTypography>
              </ArgonBox>
              <ArgonBox component="li" mb={1}>
                <ArgonTypography variant="body2">
                  Responsive design with Material-UI styling
                </ArgonTypography>
              </ArgonBox>
            </ArgonBox>

            <ArgonTypography variant="body2" color="text">
              The widget only appears when the user is authenticated. Click the
              chat button to start a conversation with support.
            </ArgonTypography>
          </ArgonBox>
        </Card>
      </ArgonBox>

      {/* Chat Widget - This will float at bottom right */}
      <ChatSupportWidget />
    </DashboardLayout>
  );
}

export default ChatWidgetTest;
